import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Spinner } from "react-bootstrap";
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../../api-client/MyApiClient';
import { sports } from "../../../../components/Util/enum";
import DEFAULT_STRUTTURA from "../../../../../images/DEFAULT_STRUTTURA.png";

// Valori dei filtri a chip (scelta multipla, all'inizio tutti accesi). Le bozze non arrivano in elenco.
const TIPO_OPTIONS = [
	{ value: 'CLOSED', label: 'Singolo' },
	{ value: 'MULTIPLO', label: 'Multiplo' },
];
const STATO_OPTIONS = ['Attivo', 'Non attivo'];

export const AdminCoursesTable = () => {
	const navigate = useNavigate();

	const [data_json, setDataJson] = useState(null);
	const [tipoFilter, setTipoFilter] = useState(TIPO_OPTIONS.map((o) => o.value));
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	// Tutto quello che non e' CLOSED la cella lo mostra come MULTIPLO.
	const filteredData = useMemo(
		() =>
			data_json &&
			data_json.filter(
				(row) =>
					filtroMultiplo(tipoFilter, TIPO_OPTIONS, row.type === 'CLOSED' ? 'CLOSED' : 'MULTIPLO') &&
					filtroMultiplo(statoFilter, STATO_OPTIONS, row.status_label?.label),
			),
		[data_json, tipoFilter, statoFilter],
	);

	const [loadingShowed, setLoadingShowed] = useState(false);
	
	const data_column = [
		{
			Header: 'Struttura',
			accessor: 'clubName',
			Cell: ({ row }) => {
				return (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img
							src={row.original.imageUrlClub ? row.original.imageUrlClub : DEFAULT_STRUTTURA}
							alt={row.original.clubName}
							style={{
								width: '40px',
								height: '40px',
								borderRadius: '50%',
								marginRight: '10px'
							}}
						/>
						<div>
							{row.original.clubName}
						</div>
					</div>
				)
			}
		},
		{
			Header: 'Nome',
			Footer: 'Nome',
			accessor: 'name',
		},
		{
			Header: 'Sport',
			Footer: 'Sport',
			accessor: 'sportType',
		},
		{
			Header: 'Inizio',
			Footer: 'Inizio',
			accessor: 'startDate',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return value ? new Date(value).toLocaleDateString('it-IT') : '-';
			}
		},
		{
			Header: 'Fine',
			Footer: 'Fine',
			accessor: 'endDate',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return value ? new Date(value).toLocaleDateString('it-IT') : '-';
			}
		},
		{
			Header: 'Prezzo base',
			Footer: 'Prezzo base',
			accessor: 'standard_price',
			disableGlobalFilter: true,
		},
		{
			Header: 'Tipo',
			Footer: 'Tipo',
			accessor: 'type',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (
					<span className={`badge ${value === 'CLOSED' ? 'badge-primary' : 'badge-primary'}`}>
						{value === 'CLOSED' ? 'SINGOLO' : 'MULTIPLO'}
					</span>
				)
			},
			disableFilters: true,
		},
		{
			Header: 'N. Acquisti',
			Footer: 'N. Acquisti',
			accessor: 'purchasesCount',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return value || 0;
			},
			disableFilters: true,
		},
		{
			Header: 'Stato',
			Footer: 'Stato',
			accessor: 'status_label',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (
					<div className="d-flex align-items-center">
						<i className={`fa fa-circle me-1 ${value?value.class:''}`}></i>
						{value?value.label:''}
					</div>
				)
			},
			disableFilters: true,
		},
	];

	function openDetail(row) {
		navigate('/superadmin/booking/courses/'+row.id);
	}
	
	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [bookingCourses] = await Promise.all([
                        apiClient.getBookingCourses(token)
                    ]);
					setLoadingShowed(false);

					if(bookingCourses) {
						let data = [];
						bookingCourses.forEach(element => {

							let status = null;
							if(element.status === 'DRAFT') {
								status = {
									"label": "Bozza",
									"class": "text-warning"
								};
							} else if(element.status === 'PURCHASABLE') {
								status = {
									"label": "Attivo",
									"class": "text-success"
								};
							} else if(element.status === 'CANCELLED') {
								status = {
									"label": "Non attivo",
									"class": "text-primary"
								};
							}

							let imageClub = null;
                            if(element.logo) {
								imageClub = element.logo;
							}

							let sportLabel = '';
							sports.forEach(element2 => {
								if(element2.value === element.sportType) {
									sportLabel = element2.label;
								}
							});

							let row = {
								"id": element.id,
								"name": element.name,
								"sportType": sportLabel,
								"startDate": element.startDate,
								"endDate": element.endDate,
								"standard_price": "€ "+(element.standard_price).toFixed(2),
								"status": element.status,
								"type": element.type,
								"status_label": status,
								"imageUrlClub": imageClub,
								"clubName": element.clubName,
								"purchasesCount": element.purchasesCount,
							};

							if(element.status !== 'DRAFT') {
								data.push(row);
							}
						});
						setDataJson(data);
					}
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

    }, []);

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<TabellaLista
				pageList={true}
				cardTitle={'Corsi'}
				hasSearch={true}
				searchPlaceholder={'Cerca per struttura, nome o sport'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						<ChipFilter label="Tipo" options={TIPO_OPTIONS} value={tipoFilter} onChange={setTipoFilter} multiple />
						<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
					</div>
				}
				data_column={data_column}
				openColumn={'name'}
				openRow={openDetail}
				canOpenRow={(row) => row.status !== 'DRAFT'}
				data_json={filteredData}
				sort_by={'name'}
                sort_type={'asc'}
				modalCallBack={() => setModalCentered(true)}
			/>
		</>
	)
}
export default AdminCoursesTable;